export const bizUnitName = {
  text: localStorage.getItem("bizUnit"),
};

export const workflowDefinition = {
  definitionId: "480",
  requestId: "122591",
};

export const CONSTANT_VALUE = {
  partner: 99,
  ho: 101,
  sales: 100,
  target_system: 70,
  target_manual: 69,
  segmentId: 24,
  nature_slab: 76,
  nature_flat: 75,
  slabType_TVA: 154,
  applicableOn_none: 77,
  calculatedOn_none: 87,
  elgRange_no: "no",
  elgRange_yes: "yes",
  slabType_NA: 153,
  level_NA: 158,
  level_PARENT: 159,
  level_CHILD: 160,
  level_SOLDTO: 161,
  source_primary: 134,
  source_secondry: 135,
  source_tertiary: 136,
  source_sellout: 137,
  supportType_percentage: 80,
  category_NA: 5,
  varietyId_PP: 59,
  incentiveAudience_PTIS: 5,
  incentiveAudience_SIS: 6,
  comm_approved: "Approved",
  comm_sentForVerification: "SentForVerification",
  comm_sentToPartners: "SentToPartners",
  schPlan_approved: "Approved",
  schPlan_inProgress: "InProgress",
  schPlan_draft: "Draft",
  // MX_id: 402, //process.env.VUE_APP_MX_ID,
  // VD_DA_id: 420, //process.env.VUE_APP_VDDA_ID,
  MX_id:  process.env.VUE_APP_MX_ID,
  VD_DA_id: process.env.VUE_APP_VDDA_ID,
  SMS_str: "SMS",
  SIS_str: "SIS",
  PTIS_str: "PTIS",
  specific_sol_to_value: 35,
  specific_partner_value: 34,
  grp_type_product_hierarchy: 29,
  grp_type_specific_product: 30,
  grp_type_specific_modal: 309,
  simulation_key: 287,
  partial_payout_key: 288,
  final_payout_key: 289,
  stock_type_NORMAL: "NORMAL - 0",
  calculatedOn_NONE: 87,
  calculatedOn_DP: 88,
  calculatedOn_DP_GST: 89,
  calculatedOn_DP_GST_Allowance: 90,
  applicableOn_VOLUME: 79,
  applicableOn_VALUE: 78,
  nature_VALUE: 56,
  nature_VOLUME: 57,
  payout_on_SELL_IN: 65,
  payout_on_SELL_THRU: 66,
  payout_on_SELL_OUT: 67,
  RRF_TOT_ID: 44,
  Segment_Stock_in_Hand: 22,
  Status_Processed: 47,
  Status_Partial_Processed: 48,
  Status_Completed: 49,
  Report_Payout:343,
  criteria_Payout:510,
  Report_Communication:344,
  Report_DOA:403,
  ERROR_EXCEL_CODE: 422,
  PROCESSING_EXCEL_CODE: 423,
  MX_BUDGET_C_REBATE: 1,
  VDDA_BUDGET_C_REBATE: 18,
  MX_BUDGET_SUB_C_REBATE: 2,
  VDDA_BUDGET_SUB_C_REBATE: 6,
  MX_VALUE: "MX",
  VDDA_VALUE: "VD/DA",
  BUDGET_TYPE_PLANNED: 108,
  BUDGET_TYPE_ADHOC: 109,
  TRADE_PLAN_DRAFT: "Draft",
  ROLL_UP_KEY:349,
  ROLL_DOWN_KEY:350,
  EQUAL_TO_KEY:351,
  SELLIN_SELL_OUT_ID:356,
  SELL_THRU_SELL_OUT:357,
  EOL: 446,
  TARGET_TIE_UP: 358,
  MODE_SYSTEM_DEFINE: 70,
  SOURCE_MT_HYBRID: 361,
  SCHEME_FAMILY_FOCUS_MODEL_VDDA : 1,
  EMPLOYEE_TARGET: 69,
  SEGMENT_PRICE_PROTECTION: 410,
  CLOSING_STOCK: 413,
  INTRANSIT_STOCK: 414,
  CLOSING_INTRNSIT_STOCK: 415,
  SOURCE_ITEM_PARTNER: 411,
  CUSTOMER_IDENTIFICATION: 412,
  PARTIAL_PAYOUT_KEY: 288,
  SUPPORT_TYPE_NA: 428 ,
  segmentId_Stock_Coverage: 184,
  OFFLINE: 433,
  ADD_PROGRAM_UPLOAD_ERROR: 'Error',
  ADD_PROGRAM_UPLOAD_COMPLETED: 'Completed',
  ADD_PROGRAM_UPLOAD_FAILED: 'File upload failed',
  VALIDATION_GROWTH: "Growth",
  VALIDATION_NEW_GROWTH: "Growth_Validation",
  GT_VDDA: 344, 
  ON_VDDA: 357, 
  MT_VDDA: 376, 
  GT_MX: 412, 
  ON_MX: 428, 
  MT_MX: 437,
  SYSTEM_MODE: 70,
  MANUAL_MODE: 69,
  SEGMENT_EOL: 23,
  FINAL_PAYOUT_COMPLETE: "FinalPayout-COMPLETED",

  slabTypeMapping: {
    "NA": "NA",
    "TVA%":  "Target",
    "Non-TVA%": "Non-Target",
  }
};

export const SIS_HIERARCHY_CONSTANT_VALUE = {
  SIS_DATA_LOOKUPS: [
    { text: "Job Id", value: 0 },
    { text: "Partner type", value: 1 },
    { text: "User Define", value: 2 },
    { text: "SoldTo", value: 3 },
  ],
  SIS_Job_Id: 0,
  SIS_Partner_Type: 1,
  SIS_User_Define: 2,
  SIS_Sold_To: 3,
  SIS_Header_active_status: 2,
  SIS_Header_in_active_status: 3,
};

export const CONSTANT_MONTH = [
  { text: "Jan", value: 1 },
  { text: "Feb", value: 2 },
  { text: "Mar", value: 3 },
  { text: "Apr", value: 4 },
  { text: "May", value: 5 },
  { text: "Jun", value: 6 },
  { text: "Jul", value: 7 },
  { text: "Aug", value: 8 },
  { text: "Sep", value: 9 },
  { text: "Oct", value: 10 },
  { text: "Nov", value: 11 },
  { text: "Dec", value: 12 },
];

export const CONSTANT_MESSAGE = {
  EXCEL_ERROR: "Error Processing file. Please check downloaded file for more details.",
  MANUAL_FREEZ: "Header Item freezed SucessFully!!!",
  EXCEL_PROCESSING: "Files Still Processing",
  EXCEL_COMPLETED: "Files Processed Successfully",
  IS_PLAN_ATTACHMENT: "Plan Attachment is not completed.",
  IS_PARTNER_RENDERING: "Partner Rendering is not completed.",
  IS_AVAILABLE_DATE_AND_TIME: "Date & Time is not completed.",
  IS_ATTACHMENT_IS_SIZE_UNDER_50MB: "Attachment size should be less than 50 MB",
  IS_COMM_EMAIL_ATTACHMENT: "Email Attachment is not completed.",
  IS_PLAN_EXIST_IN_PTIS: "PTIS Plan is not completed.",
};

export const GEO_VALUES = [
  { text: "Region", value: "Region", id: 12},
  { text: "Branch", value: "Branch", id: 15 },
  { text: "Country", value: "Country", id: 9 },
]
